<template>
  <v-card width="20rem" class="d-flex flex-column" style="max-height: 25rem;">
    <v-card-title>Note vendeur</v-card-title>
    <v-card-text class="flex-grow-1" style="overflow-y: auto;">
      <div v-if="!isEditing" class="text-left" v-html="dialogContent.value"></div>
      <div v-if="isEditing">
        <VueEditor v-model="noteValue" :editor-toolbar="customToolbar"></VueEditor>
      </div>
    </v-card-text>
    <v-card-actions class="justify-end pt-2" style="flex-shrink: 0;">
      <v-btn
        v-if="isEditing || !dialogContent.value"
        text
        @click="saveDialogContent()"
        @dblclick.stop
      >Ajouter</v-btn>
      <v-btn
        v-if="dialogContent.value && !isEditing"
        text 
        @click="isEditing = true"
        @dblclick.stop
      >Modifier</v-btn>
      <v-btn text @click.stop="deleteNote()">
        Supprimer
      </v-btn>
      <v-btn
        text
        @click="$emit('close')"
        @dblclick.stop
      >Fermer</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: { VueEditor },
  props: {
    dialogContent: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'save'],
  data() {  
    return {
      isEditing: this.dialogContent.value ? false : true,
      noteValue: this.dialogContent.value,
      customToolbar: [
      ["bold", "italic"],
      [{ list: "ordered" }, { list: "bullet" }],
    ]
    };
  },
  methods: {
    saveDialogContent() {
      this.isEditing = false;
      this.dialogContent.value = this.noteValue
      this.$emit('save', this.dialogContent)
    },
    deleteNote() {
      this.dialogContent.value = "";
      this.noteValue = "";
      this.$emit('save', this.dialogContent)
    }
  }
}
</script>

<style>
.ql-toolbar.ql-snow {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 2
}
</style>